import React, { Component } from 'react';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import OrdersAppRoot from './ordersLayout/OrdersAppRoot.jsx';
import Login from './Login.jsx';
import Login2FA from './Login2FA.jsx';
// import { setOrders } from '../../redux/actions/orders';
import { withTranslation  } from 'react-i18next';
import i18n from "../../locales";
import { applyLangFromUrl } from '../utils/urlLang';
import SimpleBar from 'simplebar-react';

import 'simplebar-react/dist/simplebar.min.css';

const conditionalRendering = (props) => {
  if (props.login.access === false && props.login.access2FA === false) {
    console.log(`props.login => `, props.login);
    return (
      <Login />
    )
  } else if (props.login.access === true && props.login.access2FA === false) {
    console.log(`props.login => `, props.login);
    return (
      <Login2FA />
    )
  } else {
    return (
      <div id="root2" className="boarderStyle">
        <SimpleBar autoHide={false} style={{ height: '100%' }}>
          <OrdersAppRoot />
        </SimpleBar>
      </div>
    )
  }
}
export class App extends Component {
  useQuery() {
    return new URLSearchParams(window.location.search);
  }

  UNSAFE_componentWillMount() {
    //this.props.dispatch(setOrders('jfarris'));
    const query = this.useQuery();
    if (!query.get("isLoginDirectly")) {
      document.getElementsByTagName('body')[0].style.backgroundImage = 'url("/wonderland_bgd.jpg")';
      document.getElementsByTagName('body')[0].style.animation = 'animatedBackground 150s linear infinite';
    }
    if (!applyLangFromUrl(i18n)) {
      const locale = localStorage.getItem('language');
      if (locale) i18n.changeLanguage(locale);
    }
  }

  componentDidUpdate() {
    // if (this.props.login.shopify === true) {
    //   document.getElementsByTagName('body')[0].style.backgroundImage = 'url()';
    //   document.getElementsByTagName('body')[0].style.animation = 'none';
    // } else {
    //   document.getElementsByTagName('body')[0].style.backgroundImage = 'url("/wonderland_bgd.jpg")';
    //   document.getElementsByTagName('body')[0].style.animation = 'animatedBackground 150s linear infinite';
    // }
  }

  render() {
    const { status, text } = this.props.display.loadingOverlay;
    return (
      <div className="app-loading-root">
        {conditionalRendering(this.props)}
        {status && (
          <div className="app-loading-overlay" role="alert" aria-busy="true">
            <CircularProgress />
            {text ? <div className="app-loading-overlay__text">{text}</div> : null}
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    login: state.login,
    display: state.display,
    userID: state.userID
  }
}

export default connect(
  mapStateToProps
)(withTranslation()(App));



// WEBPACK FOOTER //
// ./src/js/containers/App.jsx